export const INVITE_USER_DATA_REQUEST = 'INVITE_USER_DATA_REQUEST';
export const INVITE_USER_DATA_FAILURE = 'INVITE_USER_DATA_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/constants/invite_user_data.constants.js